import React from 'react'
import { LuHardHat, LuCompass, LuClipboardList, LuLayers } from "react-icons/lu";

const ServicesSection = () => {
    const services = [
        {
            title: "Project Management",
            desc: "End-to-end oversight ensuring your construction project stays on schedule and within budget.",
            icon: <LuHardHat className="text-3xl" />,
        },
        {
            title: "Architectural Plans",
            desc: "Modern, functional, and aesthetically pleasing house plans tailored to the Kenyan landscape.",
            icon: <LuCompass className="text-3xl" />,
        },
        {
            title: "BOQ Preparation",
            desc: "Accurate Bill of Quantities to prevent cost overruns and ensure material transparency.",
            icon: <LuClipboardList className="text-3xl" />,
        },
        {
            title: "MEP Drawings",
            desc: "Detailed Mechanical, Electrical, and Plumbing layouts for safe and efficient building systems.",
            icon: <LuLayers className="text-3xl" />,
        },
    ];

    return (
        <section className="py-16">
            <div className="flex flex-col items-center mb-12 text-center">
                <h2 className="text-3xl font-black font-headline text-on-surface mb-4">
                    Specilized Consultancy Services
                </h2>
                <div className="w-20 h-1.5 bg-primary rounded-full"></div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
                {services.map((service, index) => (
                    <div
                        key={index}
                        className="group p-8 bg-white rounded-xl shadow-[0_20px_40px_-15px_rgba(26,42,74,0.05)] border border-transparent hover:border-primary/20 transition-all duration-300"
                    >
                        <div className="w-14 h-14 bg-primary/10 rounded-lg flex items-center justify-center text-primary mb-6 group-hover:bg-primary group-hover:text-white transition-colors">
                            {service.icon}
                        </div>
                        <h3 className="text-xl font-bold mb-3">{service.title}</h3>
                        <p className="text-on-surface-variant text-sm leading-relaxed">
                            {service.desc}
                        </p>
                    </div>
                ))}
            </div>
        </section>
    );
};


function ConstructionSection(props) {
    return (
        <div className='container mx-auto px-3'>
            <section className="bg-surface-container-lowest relative -mt-2 rounded-2xl shadow-[0_20px_40px_-15px_rgba(26,42,74,0.1)] border border-outline-variant/30">
                <div className="grid grid-cols-1 md:grid-cols-3 divide-y md:divide-y-0 md:divide-x divide-outline-variant/20 py-8">
                    <div className="flex flex-col items-center justify-center p-6 text-center">
                        <span className="text-4xl font-black text-primary mb-2">20+</span>
                        <span className="text-sm font-label uppercase tracking-widest text-on-surface-variant font-bold">
                            Projects Delivered
                        </span>
                    </div>
                    <div className="flex flex-col items-center justify-center p-6 text-center">
                        <span className="text-4xl font-black text-primary mb-2">4+</span>
                        <span className="text-sm font-label uppercase tracking-widest text-on-surface-variant font-bold">
                            Years Experience
                        </span>
                    </div>

                    <div className="flex flex-col items-center justify-center p-6 text-center">
                        <span className="text-4xl font-black text-primary mb-2">100%</span>
                        <span className="text-sm font-label uppercase tracking-widest text-on-surface-variant font-bold">
                            Client Satisfaction
                        </span>
                    </div>
                </div>
            </section>
            <ServicesSection/>
        </div>
    )
}

export default ConstructionSection